<template>
  <v-form ref="form" v-model="component.valid" @submit.prevent>

    <div class="field-label">Período</div>
    <v-row dense align="center">
      <v-col cols="12" sm="2">
        <v-text-field
          outlined
          dense
          hide-details="auto"
          placeholder="Data inicial"
          type="date"
          v-model="component.report.date_initial_close_cashier"
          :rules="[() => !!component.report.date_initial_close_cashier || 'Campo obrigatório']"
        />
      </v-col>
      <v-col cols="auto" class="d-flex align-center pb-1 px-2">
        <span class="date-sep">–</span>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field
          outlined
          dense
          hide-details="auto"
          placeholder="Data final"
          type="date"
          v-model="component.report.date_finish_close_cashier"
          :rules="[() => !!component.report.date_finish_close_cashier || 'Campo obrigatório']"
        />
      </v-col>
    </v-row>

    <div class="field-label mt-4">Caixa</div>
    <v-row dense>
      <v-col cols="12" sm="8">
        <v-select
          outlined
          dense
          hide-details="auto"
          placeholder="Selecione o caixa"
          v-model="component.report.selectCashier"
          :items="component.cashier"
          :rules="[() => !!component.report.selectCashier || 'Campo obrigatório']"
          :disabled="component.noCashierLinked"
          :hint="component.noCashierLinked ? 'Nenhum caixa vinculado ao seu usuário' : ''"
          :persistent-hint="component.noCashierLinked"
          item-text="description"
          item-value="id"
        />
      </v-col>
    </v-row>

    <v-divider class="my-4" />

    <div class="toggle-row">
      <span class="toggle-label">Agrupar Orçamentos em Andamento</span>
      <v-switch
        v-model="component.report.generate_with_budget"
        dense
        hide-details
        inset
        class="mt-0 pt-0"
      />
    </div>

    <div class="toggle-row">
      <span class="toggle-label">Retirar crédito</span>
      <v-switch
        v-model="component.report.filter_credit"
        dense
        hide-details
        inset
        class="mt-0 pt-0"
      />
    </div>

  </v-form>
</template>

<script>
export default {
  props: {
    component: Object,
  },

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style scoped>
.field-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
  letter-spacing: 0.02em;
}

.date-sep {
  font-size: 16px;
  color: #94a3b8;
  font-weight: 400;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}

.toggle-row:last-child {
  border-bottom: none;
}

.toggle-label {
  font-size: 13px;
  color: #334155;
}
</style>
